import React, { useState } from 'react'
import './float-access.scss'
import iconCall from '../../../assets/images/icons/float.svg'
import iconClose from '../../../assets/images/icons/icon-close.svg'
import Redirect from '../redirect/redirect'
import { useStaticQuery, graphql } from "gatsby"
import { utilGtm } from '../../../utils/utilGtm'

const FloatAccess = () => {
    const [activeMenu, setactiveMenu] = useState(false)

    const { contentfulInformacionGeneral } = useStaticQuery(graphql`
    {
      contentfulInformacionGeneral {
        enlaceAAgenciasYCajeros
        enlaceAContctanos
        enlaceAPreguntasFrecuentes
        imagenBotonAccesosACajerosYAgencias {
          file {
            url
          }
        }
        imagenBotonAccesosAContactanos {
          file {
            url
          }
        }
        imagenBotonPreguntasFrecuentes {
          file {
            url
          }
        }
        textoDeAccesoAContctanos
        textoDeAccesoAgenciasYCajeros
        textoDeAccesoPreguntasFrecuentes
      }
    }
  `)

    const { enlaceAAgenciasYCajeros, 
        enlaceAContctanos, 
        enlaceAPreguntasFrecuentes, 
        imagenBotonAccesosACajerosYAgencias, 
        imagenBotonAccesosAContactanos,
        imagenBotonPreguntasFrecuentes, 
        textoDeAccesoAContctanos, 
        textoDeAccesoAgenciasYCajeros, 
        textoDeAccesoPreguntasFrecuentes } = contentfulInformacionGeneral

    const listAccess = [
        {
            icon: imagenBotonAccesosACajerosYAgencias.file.url,
            titulo: textoDeAccesoAgenciasYCajeros,
            url: enlaceAAgenciasYCajeros
        },
        {
            icon: imagenBotonPreguntasFrecuentes.file.url,
            titulo: textoDeAccesoPreguntasFrecuentes,
            url: enlaceAPreguntasFrecuentes
        },
        {
            icon: imagenBotonAccesosAContactanos.file.url,
            titulo: textoDeAccesoAContctanos,
            url: enlaceAContctanos
        },

    ]

    return (
        <>
            <div className="a-float-button gtmPaginaClicCallCenter" onClick={() => setactiveMenu(!activeMenu)}>
                <img
                    className="a-float-button-icon"
                    alt="Ícono de botón flotante"
                    src={activeMenu ? iconClose : iconCall}
                />
            </div>

            <div className={"a-float-menu " + (activeMenu ? 'active' : '')}>
                {listAccess.map((item, index) => {
                    return (
                        <Redirect key={index} gtm={ utilGtm('gtmBotonFlotanteClicAcceso', item.titulo) } url={item.url} className="a-float-redirect">
                            <div className="a-float-redirect-label">
                                {item.titulo}
                            </div>
                            <div className="a-float-redirect-icon">
                                <img
                                    className="a-float-redirect-icon-src"
                                    alt="Ícono de redirección botón flotante"
                                    src={item.icon}
                                />
                            </div>
                        </Redirect>
                    )
                })}
            </div>
        </>
    )
}

export default FloatAccess
